import styled from 'styled-components';

export const SelectCoveragePlanHeaderWrapper = styled.div`
  div {
    box-sizing: border-box;
  }
`;
